import React from 'react';
import clsx from 'clsx';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outline' | 'ghost';
  className?: string;
};

export default function Button({
  children,
  className,
  size = 'md',
  variant = 'default',
  ...props
}: ButtonProps) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded-md font-semibold transition-colors whitespace-nowrap',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500',
        size === 'sm' && 'px-3 py-1.5 text-sm',
        size === 'md' && 'px-4 py-2 text-base',
        size === 'lg' && 'px-5 py-3 text-lg',
        variant === 'default' &&
          'bg-gradient-to-r from-purple-600 to-indigo-600 text-white',
        variant === 'outline' &&
          'border border-purple-500 text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/30',
        variant === 'ghost' &&
          'text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/30',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
